export default __webpack_public_path__ + "static/media/hand-paper-solid.ad7c8611.svg";